module.exports = __webpack_public_path__ + "static/jam-e228567c53204c88c000f4759304aa9e.jpg";